module.exports = __webpack_public_path__ + "img/11.dc894c72.png";